
const getJWT = async(auth) => {
    if(!auth) return;
    const session = await auth?.currentSession();
    if(!session) return;
    return session.getIdToken().getJwtToken();
}

export default getJWT;
